import { FormControl, FormGroup } from '@angular/forms';

export class LoginValidator {

  static MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  static validCitizenId(fc: FormControl) {
    if (fc.value == null || fc.value == '') {
      return (null);
    }

    const val = fc.value;
    let sum = 0;

    if (val.length != 13) {
      return ({ validCitizenId: true });
    }

    for (let i = 0; i < 12; i++) {
      sum += parseFloat((val.charAt(i))) * (13 - i);
    }

    if ((11 - sum % 11) % 10 != parseFloat(val.charAt(12))) {
      return ({ validCitizenId: true });
    }

    return (null);
    // if(id.length != 13) return false;
    // for(i=0, sum=0; i < 12; i++)
    //   sum += parseFloat(id.charAt(i))*(13-i);
    // if((11-sum%11)%10!=parseFloat(id.charAt(12)))
    //   return false; return true;
  }
}
